import React, {Fragment, useEffect} from "react";


import clientconfigwebapp, {
    check_login_appbk,
    empty_bk,
    getLengt_arraybk,
    modal_login_reg_bk_show,
    redirectbh_typeb,
    scrollTo_uphk,
    Token_get_appbk,
} from "../../clientconfigwebapp";
import {useParams} from "react-router-dom";
import serialize from "form-serialize";
import axios from "axios";
import {toast, ToastContainer} from "react-toastify";
import ClipLoader from "react-spinners/ClipLoader";


const Select_User_Type_View = (props) => {

    const {type_user_login_reg} = useParams();

    useEffect(() => {

        scrollTo_uphk();

        Load_api_page();
    }, [1]);



    const Load_api_page = () => {

        if (check_login_appbk() == false) {
            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login-register");
        }

        const config = {
            headers: {Authorization: `Bearer ${Token_get_appbk()}`}
        };


       //// Setloadinghkfullshow("true");

        let form_data = document.querySelector('#form_data_switch_panel');
        if (form_data != null) {
            let formDatanew = new FormData(form_data);
            let data_serialize = new URLSearchParams(formDatanew).toString();


            axios.post(`${clientconfigwebapp.siteurl}api/v1/panel/switch-panel/`, data_serialize, config)


                .then((res) => {
                    ///  Setloadinghkfullshow("false");
///console.log(res.data);
                    if (String(res.data).length > 0) {

                        if (String(res.data.data) == "login-show") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "login");
                        }


                        if (String(res.data.data) == "success") {
                            redirectbh_typeb(String(clientconfigwebapp.webappurl) + "panel/dashboard");
                        }else{
                            if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                                position: "top-center",
                                autoClose: 5000,
                                hideProgressBar: false,
                                closeOnClick: true,
                                pauseOnHover: true,
                                draggable: true,
                                progress: undefined,
                            });
                        }



                    } else {
                        if (String(res.data.msgwebapp).length > 0) toast.error(res.data.msgwebapp, {
                            position: "top-center",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                        });
                    }

                }).catch((err) => {

                toast.error('خطا اتصال به سرور کد  435346', {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });


        }







    }

    return (
        <Fragment>
            <ToastContainer/>

            <form id={"form_data_switch_panel"}>
<input style={{display:"none"}} type={"text"} name={"type_user"} value={String(type_user_login_reg)}  />

            </form>


            <div className={"switch_panel_box"} style={{"display":"flex","textAlign":"center","width":"100%","flexDirection":"column","alignContent":"center","justifyContent":"center","alignItems":"center","height":"100vh"}}>

                <ClipLoader color="#01A3D4" />

              <div style={{"fontSize":"16px","display":"block","marginTop":"17px","color":"#979797"}}>  چند لحظه منتظر بمانید ...</div>

            </div>

        </Fragment>
    );
}

export default Select_User_Type_View;